import { useEffect, useMemo, useState } from "react";
import ReactTooltip from "react-tooltip";
import ReactTableTrademo from "@shared/trademo-datatable/react-table-trademo";
import styles from "./TableData.module.scss";
import { getFavouriteDetailsHandler } from "@redux/Bookmark/bookmark.action";
import { useDispatch, useSelector } from "react-redux";
import { FavouriteSingleDeleteModal } from "@components/templates/Favourite/FavouriteSingleDeleteModal";
import moment from "moment";
import { noTags, profileType } from "@utils/enum";
import { navigateToProfileHandler } from "../../utils/helper";
import { loadingBookmarkData } from "@redux/Bookmark/bookmarksSlice";
import { pendoEventType, tradeLanesPayload } from "../../utils/constant";
import getTrackingEventDictionary from "@core/dictionary/tracking-event";
import { generateTrackingObject } from "@core/global/global-country-functions";
import { trademoTrackingEvents } from "@core/global/trademo-tracking";
import Notes from "@shared/notes";
import { setRedirectionIdsArrayHandler } from "@redux/User/userDetailsSlice";

export const TableData = ({ setSelectedCompanyArray, selectedCompanyArray, setShowFavModal, clearSelectedCompanies, type, payload, setPayload, perPage, setPerPage, currentpage, setCurrentPage, setSingleData, singleData }) => {
  const [showSingleData, setShowSingleData] = useState(false);
  const state = useSelector((state) => state.bookmarkDetails.bookmarkData);
  const redirectionIdsArr = useSelector((state) => state?.userDetails?.redirectionIdsArr ?? []);
  let paginateCount = 60;

  const dispatch = useDispatch();

  const favouriteCompaniesColumns = useMemo(() => {
    let column = [
      {
        name: "S. No",
        selector: "serial_no",
        maxWidth: "50px !important",
        minWidth: "50px !important",
      },
      {
        name: "Added On",
        wrap: true,
        maxWidth: "100px !important",
        minWidth: "100px !important",
        selector: (row) => <div>{moment(row.created_at).format("MMM DD, YYYY")}</div>,
      },
      {
        name: "Trade Lanes",
        wrap: true,
        grow: 4,
        maxWidth: "350px !important",
        minWidth: "350px !important",
        selector: (row) => (
          <div key={row?.company_id}>
            {row?.company_id && row?.company_name !== "" ? (
              <div className="d-flex justify-content-between align-items-center">
                <p
                  onClick={() => {
                    dispatch(setRedirectionIdsArrayHandler(row.company_id));
                    trademoTrackingEvents(getTrackingEventDictionary.dashboardFavourites + pendoEventType[type] + "navigation", { ...generateTrackingObject(`intel-${type}-favourite`), name: row.company_name });
                    navigateToProfileHandler(row, "trade_region");
                  }}
                  className={`${styles.favouriteCompanyText} ${redirectionIdsArr.includes(row.company_id) ? `${styles.text_visited}` : ""}`}>
                  {row.company_name}
                </p>
                <Notes comingFrom="dashboard" count={row.notes_count} id={row.id} profileType={profileType.tradeLanes} />
              </div>
            ) : (
              <span className={styles.noDataText}>NA</span>
            )}
          </div>
        ),
      },
      {
        name: "Tags",
        wrap: true,
        grow: 8,
        maxWidth: "250px !important",
        minWidth: "250px !important",
        selector: (row) => (
          <div
            onClick={() => {
              setShowFavModal(true);
              setSelectedCompanyArray([{ ...row }]);
              trademoTrackingEvents(getTrackingEventDictionary.dashboardFavourites + pendoEventType[type] + "add_edit_tag", { ...generateTrackingObject(`intel-${type}-favourite`), name: row.company_name });
            }}>
            {row?.tags?.length && row.tags.filter((filterKey) => filterKey !== noTags).length ? (
              <div className="d-flex align-items-center flex-wrap">
                {row?.tags?.map((item) => (
                  <span key={item} data-tip={item} data-for="datatipID" className={`${styles.simpleTag} mr-1`}>
                    {item ? item.slice(0, 30) : ""}
                    {!!item && item.length > 30 ? "..." : ""}
                  </span>
                ))}
                {row?.tags?.length > 0 && row.tags.filter((filterKey) => filterKey !== noTags).length > 0 ? (
                  <span className={`${styles.simpleEditTag} cursor-pointer`}>
                    <p className="m-0">edit</p>
                  </span>
                ) : (
                  ""
                )}
              </div>
            ) : (
              <span className={`d-flex align-items-center cursor-pointer ${styles.simpleEditTag}`}>add tag</span>
            )}
            <ReactTooltip className="trademo-tooltip" textColor="#FFFFFF" place="top" id="datatipID" />
          </div>
        ),
      },
      {
        name: "Action",
        wrap: true,
        selector: (row) => (
          <div className="cursor-pointer">
            <span
              onClick={() => {
                setSingleData(row);
                setShowSingleData(true);
                trademoTrackingEvents(getTrackingEventDictionary.dashboardFavourites + pendoEventType[type] + "delete", { ...generateTrackingObject(`intel-${type}-favourite`), name: row.company_name });
              }}
              className="mx-2">
              <ReactTooltip className="trademo-tooltip" textColor="#FFFFFF" place="top" id="deleteFavourite" />
              <span data-tip={"Remove"} data-for="deleteFavourite" className={`material-symbols-outlined ${styles.favIcon}`}>
                delete
              </span>
            </span>
          </div>
        ),
      },
    ];

    return column;
  }, [type]);

  useEffect(() => {
    setCurrentPage(1);
  }, [payload]);

  const handleTrademoTablePageChange = (page, perPage) => {
    setPerPage(perPage);
    setCurrentPage(page);
    const requiredValue = page * perPage;
    if (!(!!state?.data[requiredValue + 1] && state?.data[requiredValue + 1] !== "") && requiredValue + 1 < state?.filteredFavouriteDataCount) {
      let payloadClone = { ...payload };
      payloadClone.from = payloadClone.from + paginateCount;
      dispatch(loadingBookmarkData());
      dispatch(getFavouriteDetailsHandler({ payload: payloadClone, type: "pagination" }));
      setPayload(payloadClone);
    }
  };

  return (
    <div className="mt-3">
      <ReactTableTrademo
        columns={favouriteCompaniesColumns}
        data={state?.data || []}
        onSelectedRowsChange={(data) => setSelectedCompanyArray(data)}
        paginationTotalRows={state?.filteredFavouriteDataCount || 0}
        clearSelectedRows={clearSelectedCompanies}
        paginationPerPage={perPage}
        paginationDefaultPage={currentpage}
        selectedData={selectedCompanyArray}
        onChangeRowsPerPage={(data) => {
          setPerPage(data);
        }}
        onTableObjectChange={(data) => {
          setPerPage(data.perPage);
          setCurrentPage(data.currentPage + 1);
        }}
        onChangePage={(page, perPage) => {
          handleTrademoTablePageChange(page, perPage);
        }}
        hideSorting={true}
        hideBorder={true}
      />
      {showSingleData ? <FavouriteSingleDeleteModal setSingleData={setSingleData} setCurrentPage={setCurrentPage} setPayload={setPayload} type={type} payload={tradeLanesPayload} selectedCompany={singleData} showSingleData={showSingleData} setShowSingleData={setShowSingleData} /> : ""}
    </div>
  );
};
